
// src/firebase/firestore.js
import { app } from './firebase'; // ✅ app must be exported
import {
  getFirestore,
  doc,
  setDoc,
  getDoc,
  updateDoc,
} from 'firebase/firestore';

// ✅ Get Firestore instance from app
const db = getFirestore(app);

// ✅ Save user data
export const saveUserData = async (userId, data) => {
  try {
    const userRef = doc(db, 'users', userId); // /users/{uid}
    await setDoc(userRef, data);
    console.log('✅ User saved to Firestore');
  } catch (error) {
    console.error('❌ Firestore save error:', error);
    throw error;
  }
};

// ✅ Get user data
export const getUserData = async (userId) => {
  const snapshot = await getDoc(doc(db, 'users', userId));
  return snapshot.exists() ? snapshot.data() : null;
};

// ✅ Update user data
export const updateUserData = async (userId, newData) => {
  await updateDoc(doc(db, 'users', userId), newData);
};

export default db;
